export interface IInvestmentDetails {
  productId: string;
  name: string;
  accountBalance: {
    value: number;
    formatted: string;
  };
  buttons: {
    type: string;
    value: number;
    formatted: string;
  }[];
  minimumInvestment: {
    value: number;
    label: string;
    formatted: string;
  };
  maximumInvestment?: {
    value: number;
    label: string;
    formatted: string;
  };
  maximumInvestmentQuantity?: {
    value: number;
    label: string;
    formatted: string;
  };
  minimumInvestmentQuantity?: number;
  investmentWindow: {
    label: string;
    value: string;
  };
  unitPrice: {
    value: number;
    label: string;
    formatted: string;
  } | null;
  currentBalance: {
    value: number;
    label: string;
    formatted: string;
  } | null;
  increment: {
    value: number;
    label: string;
    formatted: string;
  };
}

export interface IInvestmentAmount {
  amount: {
    value: number;
    formatted: string;
  };
  quantity: {
    value: number;
    label: string;
  };
}

export interface IInvestmentReview {
  amount?: number;
  productId: string;
  title: string;
  subtitle: string;
  productName: string;
  productDescription?: string;
  reservationAmount: number;
  symbol?: string;
  productInfo: {
    label: string;
    value: string;
    details: IDetails | null;
  }[];
}

export interface IDetails {
  title: string;
  description: string;
  button: {
    label: string;
    action: () => void;
  } | null;
}

export interface IInvestmentConclusion {
  title: string;
  subtitle: string;
  productId: string;
  productName: string;
  productDescription: string;
  symbol: string;
  investmentInfo: {
    label: string;
    value: string;
  }[];
}

export interface IRiskSignature {
  customerRiskProfile: {
    label: string;
    value: string;
  }[];
  requestRisksSignature: {
    formatted: {
      formatted: string;
      value: string;
    };
    label: string;
    productId: string;
  }[];
}

export interface ITermSignature {
  requestTermsSignature: {
    productId: string;
    productName: string;
    productDescription?: string;
    symbol?: string;
    documents: {
      label: string;
      url: string;
    }[];
  }[];
}

export interface IStructuredOperationsSelection {
  title: string;
  symbol: string;
  accountBalance: { value: number; formatted: string };
  availableQuantity: number;
}

export interface ICustomOperationInfoResponse {
  productId: string;
  top: { label: string; value: number; formatted: string };
  title: string;
  symbol: string;
  subtitle: string;
  helper: string;
  shortcuts: ICustomOperationInfoButton[];
  items: ICustomOperationInfoItem[];
}

export interface ICustomOperationInfoButton {
  type: string;
  value: number;
  formatted: string;
}

export interface ICustomOperationInfoItem {
  label: string;
  value: null | string;
  style?: string;
}

export interface IProductSelection {
  id: string;
  name: string;
  symbol: string;
  type: string;
}

export interface IProductInfoResponse {
  productId: string;
  top: {
    label: string;
    value: number;
    formatted: string;
  };
  title: string;
  symbol: string;
  subtitle: string;
  helper: string;
  shortcuts: IProductInfoButton[];
  items: IProductInfoItem[];
}

export interface IProductInfoButton {
  type: string;
  value: number;
  formatted: string;
}

export interface IProductInfoItem {
  label: string;
  value: null | string;
  style?: string;
}

export interface IAmountIncrement {
  result: {
    value: number;
    formatted: string;
  };
  quantity: number;
}

export enum IncrementOperation {
  Add = 'Add',
  Subtract = 'Subtract'
}
